import { UserApi } from "@/api/user.js";

export const getAllBreaks = () => UserApi("system-break", {}, "GET");
export const getActiveBreak = () => UserApi("system-break/active", {}, "GET");
export const startBreak = (data) => UserApi("system-break", data, "POST");
export const stopBreak = () => UserApi("system-break", {}, "DELETE");
export const deleteBreak = (id) => UserApi(`system-break/${id}`, {}, "DELETE");
